module.exports = __webpack_public_path__ + "img/design-text.05ac0921.png";